import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import "../loader.css";

function ManagerList(props) {
  const [UserList, setUserList] = useState([]);
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    LoadUsers();
  }, []);

  const LoadUsers = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllUserProf`).then((res) => {
      //console.log("list", res.data)
      setUserList(res.data);
      setIsLoading(false);
    });
  };
  // ShowIntents
  const ShowIntents = (pid, pName) => {
    localStorage.setItem("PatQusId", pid);
    localStorage.setItem("PatName", pName);
    // localStorage.setItem('Backvalue',backval)
    localStorage.removeItem("Backvalue");

    //console.log("the vaue", pid)
  };
  const EditManager = (valid) => {
    localStorage.setItem("ManegerId", valid);
  };

  const InsertQues = (valid, pName, backval) => {
    localStorage.setItem("PatQusId", valid);
    localStorage.setItem("PatName", pName);
    localStorage.setItem("BackQues", backval);

    //console.log("the vaue", valid)
  };

  const deleteManager = (value) => {
    //console.log("the vaue", value)

    const datavalue = {
      Did: value,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteManager`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      .then((res) => {
        //console.log("get value", res);

        //console.log("success")
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/index");
  };

  const handleChecked = (e, valid) => {
    //console.log("checked value", e.target.checked == true ? 1 : 0, valid)
    // //console.log("checked value" , chkval ,valid )
    let formDataSet = new FormData();

    formDataSet.append("usrId", valid); //append the values with key, value pair
    formDataSet.append("Usta", e.target.checked == true ? 1 : 0);

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/UpdateLogin`,
      data: formDataSet,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      .then((res) => {
        //console.log("get value", res.data.SuccessResult);
        // //console.log("success")
        if (res.data.SuccessResult == "Notfound") {
          Swal.fire({
            title: "Error",
            text: "Manager Not assign to any portal",
            icon: "error",
            confirmButtonText: "Ok",
          }).then(function () {
            window.location.reload(true);
          });
        } else {
          Swal.fire({
            title: "Success",
            text: "Profile updated Successfully",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(function () {
            window.location.reload(true);
          });
        }
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };

  return (
    <>
      <div className="page-content-wrapper">
      {isLoading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
          <div className="my-wrapper">
          <div class="spinner center">
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
        </div>
          </div>
        
        </div>
        ) : (
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">List of Managers</div>
              </div>
            </div>
            <div className="page-title-breadcrumb">
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block"
                  style={{backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38"}}
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-head">
                      <header>Manager List</header>
                      <div className="tools"></div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              {/* <th>Id</th> */}
                              <th width="30%"> Name</th>
                              <th width="20%">Email</th>
                              <th>Organization</th>
                              <th className="th-action">Action</th>
                              <th>ID Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {UserList &&
                              UserList.length > 0 &&
                              UserList.map((item) => (
                                <tr>
                                  {/* <td className="text-left">{item.id}</td> */}
                                  <td>
                                    <Link
                                      to="/UpdateManager"
                                      onClick={() => EditManager(item.uid)}
                                    >
                                      {item.first_Name}
                                      {item.lastname}
                                    </Link>{" "}
                                  </td>
                                  <td className="text-left">{item.emailid}</td>
                                  <td className="text-left">
                                    {item.organization}
                                  </td>

                                  <td>
                                    <Link
                                      to="/UpdateManager"
                                      onClick={() => EditManager(item.uid)}
                                      className="btn btn-xs py-2"
                                      style={{backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38"}}
                                    >
                                      <i className="fa fa-pencil"></i>
                                    </Link>
                                    <button
                                      className="btn btn-danger btn-xs py-2"
                                      onClick={() => {
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "You won't be able to revert this!",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#6777ef",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText: "Yes, delete it!",
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            deleteManager(item.uid);
                                          }
                                        });
                                      }}
                                    >
                                      <i className="fa fa-trash-o "></i>
                                    </button>
                                  </td>
                                  <td>
                                    <input
                                      type="checkbox"
                                      id="checkbox1"
                                      className="checkbox py-2"
                                      onChange={(e) =>
                                        handleChecked(e, item.uid)
                                      }
                                      defaultChecked={
                                        item.isActive == true ? "checked" : ""
                                      }
                                    />
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        )
      }
      </div>
    </>
  );
}

export default ManagerList;
